import { FC, useState } from 'react';
import { twMerge } from 'tailwind-merge';
import { EyeIconActive, EyeIconDefault, EyeIconHover } from './input-field-v2.assets';
import { InputPropsV2 } from './input-field-v2.types';

export const InputFieldV2: FC<InputPropsV2> = ({
  id,
  placeholder,
  value,
  handleChange,
  type = 'text',
  password = false,
  className,
  icon,
  name,
  autoComplete = 'off',
  preventAutofill = false,
  inputMode
}) => {
  //state to maintain hover state of password icon
  const [hover, setHover] = useState(false);

  //state to maintain active state of password icon
  const [active, setActive] = useState(false);

  const [allowTyping, setAllowTyping] = useState(!preventAutofill);

  // Determine the input type based on password and active state
  const inputType = password ? (active ? 'text' : 'password') : type;

  return (
    <div
      className={twMerge(
        'border-grey-20 hover:bg-grey-5 relative flex rounded-lg  border',
        className
      )}
    >
      {password ? (
        <span
          className="password-icon absolute right-2 top-[7px] cursor-pointer"
          onMouseEnter={() => setHover(true)}
          onMouseLeave={() => setHover(false)}
          onClick={() => setActive(!active)}
        >
          {active ? <EyeIconActive /> : hover ? <EyeIconHover /> : <EyeIconDefault />}
        </span>
      ) : (
        icon && <span className="absolute right-2 top-2 cursor-pointer">{icon}</span>
      )}

      <input
        id={id}
        className="font-montserrat text-dark-gray placeholder:text-grey-50 m-auto min-h-[16px] w-[98%] rounded-lg border-none bg-transparent px-2 py-1 placeholder:text-sm placeholder:font-normal hover:border-[#d9d9d9] hover:outline-0 focus:border-[#d9d9d9] focus:outline-0"
        placeholder={placeholder}
        onChange={handleChange}
        type={inputType}
        name={name}
        value={value}
        autoComplete={autoComplete}
        readOnly={!allowTyping}
        onFocus={() => setAllowTyping(true)}
        inputMode={inputMode}
      />
    </div>
  );
};
